import React from 'react';

const Lock = () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="8.04761"
      width="14"
      height="8.55556"
      rx="1.55556"
      stroke="#6A6A6A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.11133 8.04761V4.9365C4.11133 2.78872 5.85244 1.04761 8.00022 1.04761C10.148 1.04761 11.8891 2.78872 11.8891 4.9365V8.04761"
      stroke="#6A6A6A"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default Lock;
